import { MultiMainSection } from './MultiMainSection';

export default MultiMainSection;
